
import { defineAsyncComponent, defineComponent } from 'vue';
import { ArrowLeftOutlined, CheckCircleOutlined } from '@ant-design/icons-vue';

export default defineComponent({
  components: {
    bIcon: defineAsyncComponent(() => import('@/components/BaseIcon.vue')),
    ArrowLeftOutlined,
    CheckCircleOutlined,
  },
  props: {
    backMsg: {
      type: String,
      required: true,
    },
  },
  emits: ['back'],
  setup(props, { emit }) {
    const back = () => {
      emit('back');
    };
    return {
      back,
    };
  },
});
